import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router, Params} from '@angular/router';

@Component({
  selector: 'app-resultados',
  templateUrl: './resultados.component.html',
  styleUrls: ['./resultados.component.scss']
})
export class ResultadosComponent implements OnInit {
  encuesta: any[];
  idEncuesta: any;
  loading = false
  constructor(
    public router: Router,
    private rutaActiva: ActivatedRoute
  ) { 
    this.idEncuesta = this.rutaActiva.snapshot.params.id;

        // Objeto modelo para ver encuestas por usuarios.
        this.encuesta = [
          {idencuesta: 1,usuario:1,nombreUsuario: 'Nicolas',apellidoUsuario: 'Rojas',formularioNombre: 'Formulario Ejemplo',formularioID: 1, preguntas:[{pregunta:'Indique los Mts2 que tiene el terreno', seccion:'Seccion1',tipo:'Unica',respuesta:[{opcion:'1200',puntos:5}]},{pregunta:'Medidas en terrenos con areas boscosas mayor a 300mts', seccion:'Seccion2',tipo:'Multiple',respuesta:[{opcion:2300,puntos:5},{opcion:1300,puntos:5}]}]}        ];
        console.log(this.encuesta);
  }

  ngOnInit() {
  }
  onGoTo() {
    this.router.navigate(["dashboard/encuestas"]);
  }
}
